<template>
  <div>
    <!-- <transition name="modal">
      <delete-modal
        v-if="showDeleteModal"
        :loading="loadingDelete"
        @close="closeDeleteModal"
        @confirmDelete="deleteBranch"
      ></delete-modal>
    </transition> -->

    <div class="flex items-center space-x-4">
      <h2>Editar Sucursal</h2>
    </div>

    <div
      v-if="!loading"
      class="card mt-2"
    >
      <form @submit.prevent="save">
        <section-header title="Configuración de Sucursal" />

        <div class="form-grid">
          <div class="form-field">
            <label for="name">Nombre</label>
            <input id="name" type="text" v-model="form.name" />
            <validation-errors :errors="errorFor('name')"></validation-errors>
          </div>

          <div class="form-field">
            <label for="local_delivery_default_price"
              >Precio default de envío</label
            >
            <input
              id="local_delivery_default_price"
              type="number"
              step="any"
              v-model="form.local_delivery_default_price"
            />
            <validation-errors
              :errors="errorFor('local_delivery_default_price')"
            ></validation-errors>
          </div>

          <div class="form-field">
            <label for="local_delivery_max_weight"
              >Peso máximo por envío (opcional)</label
            >
            <input
              id="local_delivery_max_weight"
              type="number"
              step="any"
              v-model="form.local_delivery_max_weight"
            />
            <validation-errors
              :errors="errorFor('local_delivery_max_weight')"
            ></validation-errors>
          </div>
        </div>

        <div class="flex items-center mt-6">
          <input
            id="pickup_delivery"
            type="checkbox"
            class="h-5 w-5"
            v-model="form.pickup_delivery"
          />
          <span
            for="pickup_delivery"
            class="ml-2 text-sm font-medium text-content-700"
            >Habilitar recoger en sucursal</span
          >
        </div>

        <primary-button type="submit" class="mt-10 mx-0" :loading="loadingForm"
          >Guardar
        </primary-button>
      </form>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import validationErrors from "@/mixins/validationErrors";
import deleteMixin from "@/mixins/deleteMixin";
import { is422 } from "@/utils/response";
export default {
  name: "Branch Form",

  data() {
    return {
      states: null,
      form: {
        name: "",
        pickup_delivery: false,
        local_delivery_default_price: "",
        local_delivery_max_weight: "",
      },
      loading: false,
      loadingForm: false,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "profile");

    this.loadStates();
    this.loadBranch();
  },

  mixins: [validationErrors, deleteMixin],

  methods: {
    async loadStates() {
      this.loading = true;

      try {
        this.states = await api.resources.getStates();
      } catch (error) {}

      this.loading = false;
    },

    async loadBranch() {
      this.loading = true;

      try {
        let branch = await api.branches.getById(this.$route.params.id);

        delete branch.address;
        delete branch.local_delivery_ranges;

        this.form = await JSON.parse(JSON.stringify(branch));
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    save() {
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      this.updateBranch();
    },

    validateForm() {
      this.errors = {};

      if (!this.form.name) {
        this.errors["name"] = ["Campo requerido"];
      }

      if (!this.form.local_delivery_default_price) {
        this.errors["local_delivery_default_price"] = ["Campo requerido"];
      }

      return Object.keys(this.errors).length === 0;
    },

    async updateBranch() {
      this.loadingForm = true;

      try {
        const response = await api.branches.update(
          this.$route.params.id,
          this.form
        );
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: "profileDetail" });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },
  },
};
</script>

<style>
input[type="checkbox"] {
  accent-color: #5E3A9A;
}
</style>